/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useServiceContext } from '~/root'

const Info = ({ packageData }: any) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  return (
    <div>
      <div className="row no-gutters">
        <div className="form-group mcc-form-group col-xs-4 wparag">
          <label>{translate('SETTINGS_PACKAGE_NAME')}</label>
          <p>{packageData?.name}</p>
        </div>
      </div>
      <div className="row no-gutters">
        <div className="form-group mcc-form-group col-xs-4 wparag">
          <label>{translate('EMTF_LEVEL')}</label>
          <p>{translate('EMTF_MD_' + packageData?.level)}</p>
        </div>
      </div>
      <div className="row no-gutters">
        <div className="form-group mcc-form-group col-xs-4 wparag">
          <label>{translate('FILE_PLAN')}</label>
          <p>{packageData?.filePlanName}</p>
        </div>
      </div>
    </div>
  )
}

export default Info
